import React from "react";
import Moment from 'react-moment';
import moment from 'moment-timezone';
import { useSelector } from "react-redux";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default function DateFormater(props) {

  const locale = useSelector(state => state.app.locale);
  const timezone = useSelector(state => state.app.timezone);
  moment.locale(locale);
  const date = moment.tz(props.children, 'UTC').tz(timezone);

  const isToday = (d) => {
    if (!d) {
      return false;
    }

    return moment(d).isSame(new Date(), "day");
  }

  let format = (isToday(date)) ? 'LT' : 'ddd, LL LT';

  const renderTooltip = (dd) => (
    <Tooltip>
      {dd.format('ddd, LL LT')}
    </Tooltip>
  );

  if (!isToday(date)) {
    return (
      <Moment
        format={format}
        {...props}
      >
        {date}
      </Moment>
    );
  }

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip(date)}
    >
      <Moment
        format={format}
        {...props}
      >
        {date}
      </Moment>
    </OverlayTrigger>
  );
}
